import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/nuxtWeb/layouts/default.vue").then(m => m.default || m)),
  preview: defineAsyncComponent(() => import("/nuxtWeb/layouts/preview.vue").then(m => m.default || m))
}